import { render } from "./ActAlipayCoupons.vue?vue&type=template&id=6cd8e2f2"
import script from "./ActAlipayCoupons.vue?vue&type=script&lang=js"
export * from "./ActAlipayCoupons.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__